import { HeadCell } from 'app/agriculture/components/Table/SortableTableHead';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';

import './SortableTableHead.scss';

interface SortableTableHeadSkeletonProps {
    headCells: HeadCell<Record<string, string>>[];
    hasButton: boolean;
}

export function SortableTableHeadSkeleton({
    headCells,
    hasButton,
}: SortableTableHeadSkeletonProps) {
    return (
        <TableHead className="SortableTableHead">
            <TableRow>
                {headCells.map((headCell, index) => (
                    <TableCell
                        key={headCell.key}
                        align="left"
                        padding={index == 0 ? 'none' : 'normal'}
                    >
                        <TableSortLabel>
                            <label className="SortableTableHead__label">{headCell.label}</label>
                        </TableSortLabel>
                    </TableCell>
                ))}
                {hasButton ? <TableCell /> : null}
            </TableRow>
        </TableHead>
    );
}
